import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import PageTransition from "./components/common/PageTransition";
import Home from "./pages/Home";
import Register from "./pages/Register";
import SubPage from "./pages/SubPage";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-acem-surface text-acem-text font-sans antialiased selection:bg-acem-primary selection:text-white relative">
        <Navbar />

        <main className="flex-1 w-full max-w-7xl mx-auto max-[984px]:max-w-none max-[984px]:px-0 max-[984px]:py-0 px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/:section/:slug" element={<SubPage />} />
              <Route path="*" element={<SubPage />} />
            </Routes>
          </PageTransition>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

